/** Canonical section ids for long case study page + Content Sheet (plan §3). */
export const CASE_STUDY_SECTION_IDS = {
  hero: 'hero',
  tldr: 'tldr',
  quote: 'quote',
  /** Optional pull quote after Impact (not in default Content Sheet). */
  quoteImpact: 'quote-impact',
  /** Optional pull quote before FAQ (not in default Content Sheet). */
  quoteFaq: 'quote-faq',
  /** Legacy id; `seo_summary` is meta-only and not rendered (no on-page section). */
  seo: 'seo',
  problem: 'problem',
  oldWorkflow: 'old-workflow',
  reframing: 'reframing',
  solution: 'solution',
  workflowSchema: 'workflow-schema',
  beforeAfter: 'before-after',
  impact: 'impact',
  transferability: 'transferability',
  gift: 'gift',
  faq: 'faq',
  author: 'author',
  specialThankYou: 'special-thank-you',
  closing: 'closing',
  readAlso: 'read-also',
} as const

export type CaseStudySectionId = (typeof CASE_STUDY_SECTION_IDS)[keyof typeof CASE_STUDY_SECTION_IDS]

export const caseStudySectionIdToHash = (id: CaseStudySectionId) => `#${id}`

/** Default heading for the `collaborators` frontmatter block (credits / thanks). */
export const CASE_STUDY_SPECIAL_THANK_YOU_DEFAULT_HEADING = 'Special thank you'
